import React from "react";

import { Link } from "react-router-dom";

export default function Security() {
  return (
    <div className="min-h-screen mesh-bg">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link to="/" className="text-sm text-emerald-600">
          ← Back to home
        </Link>

        <div className="card-soft p-8 mt-6">
          <h1 className="font-display text-4xl font-bold">Security</h1>

          <p className="mt-2 text-sm text-slate-500">Last updated: May 2026</p>

          <div className="prose prose-slate dark:prose-invert max-w-none mt-8">
            <section className="space-y-4">
              <h2 className="text-2xl font-bold">1. Security Overview</h2>

              <p>
                AccessWealth is designed with security-focused infrastructure,
                authentication systems, encrypted communication channels, and
                modern protection practices to help safeguard user data and
                financial information.
              </p>

              <p>
                We continuously monitor and improve platform security to help
                protect against unauthorized access, abuse, and data compromise.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">2. Infrastructure Security</h2>

              <p>
                AccessWealth uses secure cloud infrastructure, HTTPS encrypted
                communication, protected API layers, and controlled server
                access practices.
              </p>

              <p>
                Security controls may include firewall protection, reverse proxy
                systems, access restrictions, monitoring systems, and
                infrastructure hardening techniques.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">3. Password Protection</h2>

              <p>
                Passwords are securely hashed using industry-standard hashing
                algorithms and are never stored in plain text.
              </p>

              <p>
                Authentication credentials are processed securely to reduce the
                risk of credential exposure.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">4. Encryption</h2>

              <p>
                Sensitive information is encrypted during transmission using
                HTTPS and encrypted storage practices may be applied where
                appropriate.
              </p>

              <p>
                AccessWealth continuously evaluates security controls and
                encryption practices to improve protection standards.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                5. Authentication & Access Control
              </h2>

              <p>
                AccessWealth uses authentication tokens, account verification
                mechanisms, secure sessions, and access control systems to help
                protect user accounts and platform integrity.
              </p>

              <p>
                Administrative access to infrastructure and sensitive systems is
                restricted and monitored where applicable.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                6. Vault & Document Security
              </h2>

              <p>
                Uploaded vault documents and sensitive records are protected
                using secure storage and controlled access mechanisms.
              </p>

              <p>
                While AccessWealth applies strong security practices, users
                remain responsible for ensuring that uploaded files do not
                contain malware, illegal content, or unauthorized information.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                7. Session & Device Security
              </h2>

              <p>
                AccessWealth may use secure sessions, authentication cookies,
                token validation, and session expiration controls to help reduce
                unauthorized account access risks.
              </p>

              <p>
                Users should avoid accessing accounts from untrusted devices or
                unsecured public networks.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                8. User Security Responsibilities
              </h2>

              <p>
                Users are responsible for maintaining the security of their own:
              </p>

              <ul className="space-y-2">
                <li>Passwords and authentication credentials</li>
                <li>Email accounts and recovery methods</li>
                <li>Mobile devices and computers</li>
                <li>Internet connections and browsing environments</li>
                <li>Linked nominee and family account access</li>
              </ul>

              <p>
                Users should immediately report suspicious activity,
                unauthorized access, or suspected compromise of their accounts.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">9. Third-Party Services</h2>

              <p>
                AccessWealth may rely on trusted third-party infrastructure,
                hosting, email delivery, analytics, and payment providers.
              </p>

              <p>
                While we carefully select providers, AccessWealth cannot
                guarantee the security practices of external third-party systems
                outside our direct control.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">10. Security Limitations</h2>

              <p>
                No digital platform, internet transmission method, or electronic
                storage system can guarantee absolute security.
              </p>

              <p>
                While AccessWealth implements strong safeguards, users
                acknowledge that cybersecurity risks, unauthorized attacks, and
                infrastructure failures may still occur.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                11. Reporting Security Issues
              </h2>

              <p>
                To report a security concern, vulnerability, suspicious
                activity, or potential data exposure, contact:
              </p>

              <p className="font-semibold text-emerald-600">
                info@accesswealth.in
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
